import {
  FePerson,
  useCoverageBetaStore,
  useIsPersonQaActive,
} from "@/store/useCoverageBetaStore";
import { qaItemStatusStyle } from "@/utils/build-coverage-beta-qa-result";
import { focusQaItem } from "@/utils/coverage-beta-focus";
import { cn } from "@/utils/utils";
import { ActionIcon, Badge, CheckIcon } from "@mantine/core";
import { IconArrowBackUp, IconTrash } from "@tabler/icons-react";

interface Props {
  person: FePerson;
  idx: number;
}

const ICON_SIZE = 14;

export const PersonSummaryRow = (props: Props) => {
  const { person, idx } = props;
  const { id, isDeleted } = person;

  const setPersonDeleted = useCoverageBetaStore((s) => s.setPersonDeleted);
  const isReadOnly = useCoverageBetaStore((s) => s.isReadOnly);
  const isQaMode = useCoverageBetaStore((s) => s.isQaMode);
  const isActivePerson = useIsPersonQaActive(idx);
  const setActiveQaItemKey = useCoverageBetaStore((s) => s.setActiveQaItemKey);
  const qaReasons = useCoverageBetaStore((s) => s.qaVerdicts[`person:${idx}`]);

  // Same at-a-glance review-status styling SummaryRow uses for empty areas.
  const qaStatus = qaItemStatusStyle(qaReasons);

  return (
    <div
      className={cn(
        "py-1 px-2 rounded flex gap-1.5 items-center hover:bg-gray-200/50",
        isQaMode && "cursor-pointer",
        isActivePerson && "ring-2 ring-gray-200 bg-gray-200/25",
        isDeleted && "opacity-50",
        isQaMode && qaStatus.borderClass,
      )}
      onClick={() => {
        if (!isQaMode) return;
        setActiveQaItemKey(`person:${idx}`);
        focusQaItem(`person:${idx}`);
      }}
    >
      {isQaMode && (
        <span className="flex items-center" title={qaStatus.title}>
          <CheckIcon size={ICON_SIZE} className={qaStatus.iconClass} />
        </span>
      )}

      <div className="min-w-2 shrink-0 text-right pr-1">P{idx}</div>

      <Badge size="xs" color={isDeleted ? "gray" : "red"}>
        person
      </Badge>

      <div className="ml-auto flex items-center shrink-0">
        {isReadOnly ? null : isDeleted ? (
          <ActionIcon
            variant="transparent"
            color="blue"
            onClick={() => setPersonDeleted(id, false)}
            title="Restore person"
          >
            <IconArrowBackUp size={ICON_SIZE} />
          </ActionIcon>
        ) : (
          <ActionIcon
            variant="transparent"
            color="gray"
            onClick={() => setPersonDeleted(id, true)}
            title="Delete person"
          >
            <IconTrash
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "red";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "";
              }}
              size={ICON_SIZE}
            />
          </ActionIcon>
        )}
      </div>
    </div>
  );
};
